module.exports = __webpack_public_path__ + "static/media/leaf.8b83501b.svg";